import React, { useState } from "react";

// Card component
const Card = ({ title, description }) => {
    const cardStyles = {
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "20px",
        margin: "10px",
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
        textAlign: "left",
        width: "280px",
        backgroundColor: "#fff",
    };

    return (
        <div style={cardStyles}>
            <h3 style={{ marginBottom: "10px", fontSize: "18px" }}>{title}</h3>
            <p style={{ fontSize: "14px", color: "#000", }}>{description}</p>
        </div>
    );
};

const AutomobilityTabs = () => {
    const [activeTab, setActiveTab] = useState("tab1");

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            width: "80%", // You can adjust the width of the container
            margin: "20px auto",
            marginTop: "50px"
        },
        tabNav: {
            display: "flex",
            justifyContent: "center", // Horizontally center the tabs
            borderBottom: "2px solid #ddd",
            paddingBottom:"10px",
        },
        tabButton: {
            padding: "10px 20px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "50px", // Pill shape
            margin: "0 10px", // Spacing between buttons
            backgroundColor: "#f0f0f0", // Default background color
        },
        activeTabButton: {
            borderBottom: "none", // Remove the border from active tab
            backgroundColor: "#009ca5", // Active tab background color
            color: "#fff", // Active tab text color
        },
        tabContent: {
            padding: "20px",
            fontSize: "16px",
            color: "#333",
            lineHeight: "1.5",
            textAlign: "center", // Center the text content
            display: "flex", // Use flexbox to display the cards in a row
            flexWrap: "nowrap", // Prevent cards from wrapping to the next line
            justifyContent: "space-between", // Distribute cards evenly in the row
            gap: "10px", // Add some space between the cards
            width: "100%", // Make the tabContent span the full width of the container
        },
    };



    return (
        <div style={styles.container}>
            <div style={styles.tabNav}>
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab1")}
                >
                    Platform Engineering
                </button>
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab2")}
                >
                    Autonomous Mobility
                </button>
                <button
                    style={{
                        ...styles.tabButton,
                        ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                    }}
                    onClick={() => handleTabClick("tab3")}
                >
                    Electrification
                </button>
            </div>

            <div className="container">
                <div className="row">
                    {activeTab === "tab1" && (
                        <>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Software Defined Vehicle"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Digital Cockpit"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="AI-Enabled  Experience"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Adaptive AUTOSAR"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                        </>
                    )}
                    {activeTab === "tab2" && (
                        <>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Perception Systems"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Enabling the ADAS journey"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Safety and Cybersecurity"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Adaptive AUTOSAR"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                        </>
                    )}
                    {activeTab === "tab3" && (
                        <>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Wireline and Wireless BMS"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Motor Prognostics"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="AI-Enabled  Experience"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                            <div className="col-12 col-md-6 col-lg-3 mb-4">
                                <Card
                                    title="Charging System"
                                    description="As an associate member of AUTOSAR, Envision enhances our delivery of advanced automotive solutions like Software-defined Vehicles (SDV), bolstering our market position and ensuring high-quality, standardized software solutions for evolving industry needs."

                                />
                            </div>
                        </>
                    )}
                </div>
            </div>


        </div>
    );
};

export default AutomobilityTabs;
